/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon16Light = forwardRef('ArrowDCornerLeftUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.646 6.146a.5.5 0 1 0 .708.708L6 3.207V11.5A2.5 2.5 0 0 0 8.5 14h6a.5.5 0 1 0 0-1h-6A1.5 1.5 0 0 1 7 11.5V3.207l3.646 3.647a.5.5 0 0 0 .708-.708L7.702 2.495a1.7 1.7 0 0 0-2.404 0L1.646 6.146Z" })));
});
